<template>

    <div id="app">
        <Header></Header>
        <Hero image="/static/img/shamal1.jpg"></Hero>
        <BlockC></BlockC>
        <Carousel></Carousel>
        <Footer></Footer>
    </div>


</template>

<script>

    import Header from "./components/Header";
    import Logos from "./components/Logos";
    import BlockA from "./components/BlockA";
    import Footer from "./components/Footer";
    import BlockB from "./components/BlockB";
    import Hero from "./components/Hero";
    import BlockC from "./components/BlockC";
    import Carousel from "./components/Carousel";

    export default {
        name: 'app',

        data: () => ({}),
        components: {
            Carousel,
            BlockC,
            Hero,
            BlockB,
            Footer,
            BlockA,
            Logos,
            Header,



        }
    }
</script>
